import * as React from "react";
const SvgErrorEmpty = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 68,
	height: 82,
	viewBox: "0 0 68 82",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_4473_29983)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M4.17388 50.1045L62.7051 81.949C63.407 82.3089 66.6896 80.7227 66.6896 80.0061L67.0388 30.9239C67.0388 30.5927 66.8398 30.2869 66.515 30.1213L6.26566 0.05089C5.56374 -0.309025 3.1053 1.30581 3.10181 2.02246L3.65356 49.2955C3.65356 49.6299 3.85261 49.9389 4.18087 50.1045H4.17388Z",
	fill: "url(#paint0_linear_4473_29983)"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M24.704 60.9784L15.7189 64.5616C15.3592 64.7559 15.3976 66.4822 15.7608 66.6733L34.8731 76.8305C35.0442 76.9229 35.2572 76.9229 35.4318 76.8305L44.5532 71.9064C44.9164 71.7089 44.9827 70.0049 44.6195 69.8138L25.2593 60.9752C25.0882 60.886 24.8752 60.886 24.7075 60.9784H24.704Z",
	fill: "#C1C1C1"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M24.704 59.7076L15.7572 64.5394C15.3975 64.7337 15.3975 65.2114 15.7572 65.4057L34.8695 75.563C35.0406 75.6553 35.2536 75.6553 35.4282 75.563L44.5496 70.6388C44.9128 70.4413 44.9093 69.9636 44.5426 69.7725L25.2522 59.7076C25.0811 59.6184 24.8681 59.6184 24.7005 59.7108L24.704 59.7076Z",
	fill: "url(#paint1_linear_4473_29983)"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M26.1602 67.1733L33.5285 70.9795L33.5774 63.243L26.209 59.3635L26.1602 67.1733Z",
	fill: "url(#paint2_linear_4473_29983)"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M26.2091 59.3637L26.8482 58.9783L34.213 62.8577L34.1641 70.5975L33.5286 70.9797L33.5775 63.2431L26.2091 59.3637Z",
	fill: "#C1C1C1"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M2.69674 50.7956L62.4991 81.8215C63.2045 82.1814 64.4372 81.7323 64.4372 81.0189V32.5738C64.4372 32.2425 64.2382 31.9367 63.9099 31.7711L4.44629 1.38222C3.74088 1.02231 2.85738 1.46503 2.85389 2.17849L2.16943 49.9866C2.16943 50.321 2.36848 50.63 2.69674 50.7956Z",
	fill: "url(#paint3_linear_4473_29983)"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M4.8479 49.2031L62.5061 79.092V33.5389L5.51489 4.29663L4.8479 49.2031Z",
	stroke: "#C1C1C1",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("g", { opacity: .31 }, /* @__PURE__ */ React.createElement("path", {
	d: "M13.882 17.1899L12.1778 16.2917C11.7972 16.091 11.4899 16.2121 11.4899 16.556V18.1104C11.4899 18.4575 11.7972 18.8971 12.1778 19.0977L13.882 19.9959C14.2626 20.1966 14.5699 20.0756 14.5699 19.7316V18.1773C14.5699 17.8301 14.2626 17.3905 13.882 17.1899Z",
	fill: "#2C2F30"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M15.6525 18.6868L25.137 23.681C25.3082 23.7702 25.4478 23.7192 25.4478 23.5599C25.4478 23.4039 25.3082 23.2032 25.137 23.114L15.6525 18.1198C15.4814 18.0306 15.3417 18.0816 15.3417 18.2409C15.3417 18.4001 15.4814 18.5976 15.6525 18.6868Z",
	fill: "#2C2F30"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M15.6525 19.8081L28.8911 26.7803C29.0622 26.8694 29.2019 26.8185 29.2019 26.6592C29.2019 26.5032 29.0622 26.3025 28.8911 26.2133L15.6525 19.2412C15.4814 19.152 15.3417 19.2029 15.3417 19.3622C15.3417 19.5214 15.4814 19.7189 15.6525 19.8081Z",
	fill: "#2C2F30"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M28.8911 27.3344L15.6525 20.3623C15.4814 20.2731 15.3417 20.324 15.3417 20.4833C15.3417 20.6425 15.4814 20.84 15.6525 20.9292L28.8911 27.9013C29.0622 27.9905 29.2019 27.9396 29.2019 27.7803C29.2019 27.6211 29.0622 27.4236 28.8911 27.3344Z",
	fill: "#2C2F30"
})), /* @__PURE__ */ React.createElement("g", { opacity: .31 }, /* @__PURE__ */ React.createElement("path", {
	d: "M13.882 24.006L12.1778 23.1078C11.7972 22.9072 11.4899 23.0282 11.4899 23.3722V24.9265C11.4899 25.2737 11.7972 25.7132 12.1778 25.9139L13.882 26.8121C14.2626 27.0128 14.5699 26.8917 14.5699 26.5477V24.9934C14.5699 24.6462 14.2626 24.2067 13.882 24.006Z",
	fill: "#2C2F30"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M15.6525 25.5029L25.137 30.4971C25.3082 30.5863 25.4478 30.5354 25.4478 30.3761C25.4478 30.22 25.3082 30.0194 25.137 29.9302L15.6525 24.936C15.4814 24.8468 15.3417 24.8978 15.3417 25.057C15.3417 25.2163 15.4814 25.4137 15.6525 25.5029Z",
	fill: "#2C2F30"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M15.6525 26.6243L28.8911 33.5964C29.0622 33.6856 29.2019 33.6346 29.2019 33.4754C29.2019 33.3193 29.0622 33.1187 28.8911 33.0295L15.6525 26.0573C15.4814 25.9681 15.3417 26.0191 15.3417 26.1784C15.3417 26.3376 15.4814 26.5351 15.6525 26.6243Z",
	fill: "#2C2F30"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M28.8911 34.1506L15.6525 27.1784C15.4814 27.0892 15.3417 27.1402 15.3417 27.2994C15.3417 27.4587 15.4814 27.6562 15.6525 27.7454L28.8911 34.7175C29.0622 34.8067 29.2019 34.7557 29.2019 34.5965C29.2019 34.4372 29.0622 34.2397 28.8911 34.1506Z",
	fill: "#2C2F30"
})), /* @__PURE__ */ React.createElement("g", { opacity: .31 }, /* @__PURE__ */ React.createElement("path", {
	d: "M13.882 29.8793L12.1778 28.9811C11.7972 28.7805 11.4899 28.9015 11.4899 29.2455V30.7998C11.4899 31.147 11.7972 31.5865 12.1778 31.7872L13.882 32.6854C14.2626 32.8861 14.5699 32.765 14.5699 32.421V30.8667C14.5699 30.5195 14.2626 30.08 13.882 29.8793Z",
	fill: "#2C2F30"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M15.6525 31.3762L25.137 36.3704C25.3082 36.4596 25.4478 36.4087 25.4478 36.2494C25.4478 36.0933 25.3082 35.8927 25.137 35.8035L15.6525 30.8093C15.4814 30.7201 15.3417 30.7711 15.3417 30.9303C15.3417 31.0896 15.4814 31.287 15.6525 31.3762Z",
	fill: "#2C2F30"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M15.6525 32.4976L28.8911 39.4697C29.0622 39.5589 29.2019 39.5079 29.2019 39.3487C29.2019 39.1926 29.0622 38.9919 28.8911 38.9028L15.6525 31.9306C15.4814 31.8414 15.3417 31.8924 15.3417 32.0516C15.3417 32.2109 15.4814 32.4084 15.6525 32.4976Z",
	fill: "#2C2F30"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M28.8911 40.0239L15.6525 33.0517C15.4814 32.9625 15.3417 33.0135 15.3417 33.1727C15.3417 33.332 15.4814 33.5295 15.6525 33.6187L28.8911 40.5908C29.0622 40.68 29.2019 40.629 29.2019 40.4698C29.2019 40.3105 29.0622 40.113 28.8911 40.0239Z",
	fill: "#2C2F30"
})), /* @__PURE__ */ React.createElement("path", {
	d: "M35.8195 59.1406V59.3636L39.8633 61.453V61.2332L35.8195 59.1406Z",
	fill: "#ADADAD"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M35.8195 59.1406L39.8528 57.0034L43.8583 59.1151L39.8633 61.2332L35.8195 59.1406Z",
	fill: "#D6D6D6"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M39.8633 61.4531L43.8583 59.335V59.1152L39.8633 61.2333V61.4531Z",
	fill: "#D6D6D6"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M41.8608 58.5322V62.5486L45.9047 64.638V60.6248L41.8608 58.5322Z",
	fill: "#ADADAD"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M45.9047 60.6249L49.8996 58.5037V62.5201L45.9047 64.6381V60.6249Z",
	fill: "#D6D6D6"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M49.8997 58.5035L45.8942 56.395L41.8608 58.5322L45.9047 60.6248L49.8997 58.5035Z",
	fill: "#D6D6D6"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M47.7904 57.9622V65.6669L51.8343 67.7595V60.0516L47.7904 57.9622Z",
	fill: "#ADADAD"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M51.8342 60.0517L55.8292 57.9336V65.6415L51.8342 67.7596V60.0517Z",
	fill: "#D6D6D6"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M47.7904 57.9621L51.8238 55.825L55.8292 57.9335L51.8343 60.0516L47.7904 57.9621Z",
	fill: "#D6D6D6"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M4.2403 66.4028L6.62541 67.6609C6.91525 67.8138 7.26796 67.8138 7.5578 67.6609L8.31559 67.2819C8.62639 67.1194 8.62639 66.7086 8.31559 66.5429L5.93048 65.2848C5.64064 65.1319 5.28793 65.1319 4.99809 65.2848L4.2403 65.6639C3.9295 65.8263 3.9295 66.2372 4.2403 66.4028Z",
	fill: "#2E2F2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5.76294 60.7619L6.99216 60.1089C7.30645 59.9433 7.74296 59.9783 8.24932 60.2459L7.0201 60.8988C6.51374 60.6313 6.07723 60.5963 5.76294 60.7619Z",
	fill: "black"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.02012 60.8957C8.05379 61.4404 8.76269 62.622 8.75919 63.7687C8.7557 64.9153 8.07474 65.3325 6.97822 64.756C5.94106 64.2114 5.23566 63.001 5.23915 61.9149C5.24264 60.7715 5.98646 60.3511 7.02012 60.8957Z",
	fill: "black"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M9.47509 64.2527L8.24587 64.9056C8.57413 64.7305 8.75921 64.3323 8.75921 63.7686C8.7627 62.6251 8.05381 61.4403 7.02014 60.8956L8.24936 60.2427C9.28303 60.7873 9.99193 61.969 9.98843 63.1156C9.98843 63.6794 9.80335 64.0775 9.47509 64.2527Z",
	fill: "black"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M8.17944 58.3126L9.41216 57.6597L9.44009 58.4814L8.21087 59.1344L8.17944 58.3126Z",
	fill: "black"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M3.28003 42.4381L4.50925 41.7852C5.48704 41.5527 7.17722 41.9476 8.74518 42.7725L7.51596 43.4255C5.948 42.6006 4.25782 42.2056 3.28003 42.4381Z",
	fill: "black"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.51596 43.4254C10.9173 45.2186 12.4503 48.2285 12.4433 50.5855C12.4363 52.694 11.3084 53.624 9.88361 54.6401C8.57756 55.5669 8.09914 56.6817 8.18295 58.3093L8.21089 59.131L5.9026 57.9143L5.84324 57.0767C5.67212 55.3089 6.20991 53.7578 7.69405 52.6781C9.03153 51.7353 9.77535 50.9167 9.77884 49.5216C9.78233 47.9387 8.83946 46.3875 6.97468 45.3747C5.90959 44.8141 4.72576 44.5625 3.98544 44.7631L3.28003 42.4348C4.25782 42.2023 5.948 42.5973 7.51596 43.4222V43.4254Z",
	fill: "black"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.51599 43.4254L8.74521 42.7725C12.1465 44.5657 13.6796 47.5756 13.6726 49.9325C13.6656 52.0411 12.5376 52.9711 11.1129 53.9871C9.80681 54.914 9.3284 56.0288 9.41221 57.6564L8.18298 58.3093C8.10267 56.6817 8.57759 55.5669 9.88364 54.6401C11.3084 53.6209 12.4364 52.6908 12.4434 50.5855C12.4503 48.2285 10.9208 45.2154 7.51599 43.4254Z",
	fill: "black"
}), /* @__PURE__ */ React.createElement("mask", {
	id: "mask0_4473_29983",
	style: { maskType: "luminance" },
	maskUnits: "userSpaceOnUse",
	x: 4,
	y: 60,
	width: 4,
	height: 2
}, /* @__PURE__ */ React.createElement("path", {
	d: "M4.73267 61.3766L5.96189 60.7237C6.27618 60.5581 6.71269 60.5931 7.21905 60.8606L5.98982 61.5136C5.48347 61.246 5.04696 61.211 4.73267 61.3766Z",
	fill: "white"
})), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_4473_29983)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M4.73267 61.3767L5.96189 60.7237C5.96189 60.7237 5.98982 60.7078 6.00379 60.7014L4.77457 61.3544C4.77457 61.3544 4.74663 61.3671 4.73267 61.3767Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M4.77808 61.3545L6.0073 60.7015C6.03174 60.692 6.0527 60.6824 6.07714 60.6729L4.84792 61.3258C4.82347 61.3353 4.79903 61.3449 4.77808 61.3545Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M4.8479 61.3259L6.07712 60.6729C6.09807 60.6666 6.12252 60.657 6.14696 60.6506L4.91774 61.3036C4.8933 61.3099 4.87235 61.3163 4.8479 61.3259Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M4.91772 61.3034L6.14695 60.6504C6.1679 60.6441 6.18885 60.6409 6.2098 60.6377L4.98058 61.2906C4.95963 61.2938 4.93868 61.3002 4.91772 61.3034Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M4.98059 61.2907L6.20981 60.6377C6.23077 60.6345 6.25172 60.6314 6.27267 60.6282L5.04345 61.2811C5.0225 61.2811 5.00154 61.2875 4.98059 61.2907Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5.04346 61.2811L6.27268 60.6282C6.29363 60.6282 6.31458 60.625 6.33554 60.6218L5.10632 61.2748C5.08536 61.2748 5.06441 61.2748 5.04346 61.2811Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5.10632 61.2748L6.33555 60.6218C6.3565 60.6218 6.37745 60.6218 6.3984 60.6218L5.16918 61.2748C5.14823 61.2748 5.12728 61.2748 5.10632 61.2748Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5.16919 61.2748L6.39841 60.6218C6.41936 60.6218 6.44032 60.6218 6.46127 60.6218L5.23205 61.2748C5.21109 61.2748 5.19014 61.2748 5.16919 61.2748Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5.23206 61.2782L6.46128 60.6252C6.48223 60.6252 6.50318 60.6252 6.52414 60.6316L5.29491 61.2846C5.27396 61.2846 5.25301 61.2814 5.23206 61.2782Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5.29492 61.2811L6.52414 60.6282C6.5451 60.6282 6.56605 60.6345 6.59049 60.6377L5.36127 61.2907C5.34032 61.2875 5.31937 61.2843 5.29492 61.2811Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5.36121 61.2906L6.59043 60.6377C6.61138 60.6409 6.63583 60.6441 6.65678 60.6504L5.42756 61.3034C5.4066 61.3002 5.38216 61.2938 5.36121 61.2906Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5.42761 61.3036L6.65683 60.6506C6.67779 60.6538 6.70223 60.6602 6.72668 60.6666L5.49745 61.3195C5.47301 61.3131 5.45206 61.3099 5.42761 61.3036Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5.49744 61.3194L6.72666 60.6665C6.7511 60.6729 6.77555 60.6792 6.7965 60.6856L5.56728 61.3386C5.54283 61.3322 5.51839 61.3258 5.49744 61.3194Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5.56726 61.3385L6.79648 60.6855C6.82093 60.6919 6.84537 60.7015 6.86982 60.7078L5.6406 61.3608C5.61615 61.3512 5.59171 61.3449 5.56726 61.3385Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5.64062 61.3607L6.86985 60.7078C6.89429 60.7173 6.92223 60.7269 6.95017 60.7364L5.72094 61.3894C5.69301 61.3798 5.66856 61.3703 5.64062 61.3607Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5.72095 61.3895L6.95017 60.7366C6.97811 60.7461 7.00604 60.7589 7.03398 60.7716L5.80476 61.4246C5.77682 61.4118 5.74888 61.4023 5.72095 61.3895Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5.80469 61.4244L7.03391 60.7715C7.06534 60.7842 7.09328 60.797 7.1247 60.8129L5.89548 61.4658C5.86405 61.4499 5.83612 61.4372 5.80469 61.4244Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5.89551 61.4659L7.12473 60.813C7.15616 60.8289 7.18759 60.8448 7.21902 60.8608L5.98979 61.5137C5.95837 61.4978 5.92694 61.4819 5.89551 61.4659Z",
	fill: "#F4B648"
})), /* @__PURE__ */ React.createElement("path", {
	d: "M5.9898 61.5135C7.02347 62.0581 7.73236 63.2398 7.72887 64.3864C7.72887 65.4693 7.04093 65.9471 5.94441 65.3706C4.91074 64.826 4.20184 63.6156 4.20534 62.5327C4.20883 61.3861 4.94915 60.9688 5.98631 61.5135H5.9898Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("mask", {
	id: "mask1_4473_29983",
	style: { maskType: "luminance" },
	maskUnits: "userSpaceOnUse",
	x: 5,
	y: 60,
	width: 4,
	height: 6
}, /* @__PURE__ */ React.createElement("path", {
	d: "M8.4447 64.8674L7.21548 65.5204C7.54373 65.3452 7.72882 64.9471 7.72882 64.3865C7.73231 63.2399 7.02341 62.0582 5.98975 61.5135L7.21897 60.8606C8.25263 61.4052 8.96153 62.5869 8.95804 63.7335C8.95804 64.2941 8.77296 64.6923 8.4447 64.8674Z",
	fill: "white"
})), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask1_4473_29983)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M5.98975 61.5135L7.22246 60.8606L5.99324 61.5135H5.98975Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5.99353 61.5135L7.22275 60.8606C7.25767 60.8797 7.29259 60.8988 7.32402 60.9179L6.0948 61.5709C6.05988 61.5518 6.02845 61.5326 5.99353 61.5135Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6.09448 61.5709L7.3237 60.918C7.35863 60.9371 7.39005 60.9594 7.42498 60.9785L6.19575 61.6314C6.16083 61.6091 6.1294 61.59 6.09448 61.5709Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6.1958 61.6315L7.42502 60.9785C7.45994 61.0008 7.49137 61.0231 7.52629 61.0454L6.29707 61.6983C6.26564 61.6761 6.23072 61.6538 6.1958 61.6315Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6.297 61.6984L7.52622 61.0454C7.55765 61.0677 7.58908 61.09 7.62051 61.1123L6.39128 61.7652C6.35986 61.7429 6.32843 61.7206 6.297 61.6984Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6.38782 61.7652L7.61704 61.1123C7.64498 61.1346 7.67641 61.1569 7.70434 61.1792L6.47512 61.8321C6.44718 61.8098 6.41925 61.7875 6.38782 61.7652Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6.4751 61.8321L7.70432 61.1792C7.73226 61.2015 7.7567 61.2238 7.78464 61.2461L6.55542 61.899C6.52748 61.8767 6.50303 61.8544 6.4751 61.8321Z",
	fill: "#F5BF5E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6.55542 61.899L7.78464 61.2461C7.80909 61.2684 7.83353 61.2907 7.85798 61.3098L6.62875 61.9627C6.60431 61.9404 6.57986 61.9181 6.55542 61.899Z",
	fill: "#F6C267"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6.62878 61.9628L7.85801 61.3098C7.88245 61.3321 7.9069 61.3544 7.92785 61.3767L6.69863 62.0296C6.67418 62.0073 6.65323 61.985 6.62878 61.9628Z",
	fill: "#F6C56E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6.69861 62.0294L7.92783 61.3765C7.95577 61.4019 7.98021 61.4274 8.00466 61.4561L6.77543 62.109C6.75099 62.0836 6.72305 62.0549 6.69861 62.0294Z",
	fill: "#F7C874"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6.77893 62.1092L8.00815 61.4563C8.04657 61.4945 8.08149 61.5327 8.11641 61.5742L6.88719 62.2271C6.85226 62.1857 6.81385 62.1475 6.77893 62.1092Z",
	fill: "#F7CA79"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6.88721 62.2269L8.11643 61.574C8.15833 61.6218 8.19675 61.6695 8.23865 61.7205L7.00943 62.3734C6.97102 62.3225 6.92911 62.2747 6.88721 62.2269Z",
	fill: "#F7CB7E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.00598 62.3702L8.2352 61.7173C8.26314 61.7555 8.29457 61.7937 8.32251 61.8319L7.09328 62.4849C7.06535 62.4467 7.03741 62.4084 7.00598 62.3702Z",
	fill: "#F7CA79"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.09326 62.485L8.32248 61.832C8.33994 61.8575 8.3574 61.883 8.37487 61.9085L7.14564 62.5614C7.12818 62.5359 7.11072 62.5105 7.09326 62.485Z",
	fill: "#F7C874"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.14563 62.5614L8.37485 61.9084C8.38882 61.9276 8.3993 61.9467 8.41327 61.9658L7.18404 62.6187C7.17007 62.5996 7.1596 62.5805 7.14563 62.5614Z",
	fill: "#F6C56E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.18408 62.6188L8.4133 61.9658C8.42378 61.9849 8.43775 62.004 8.44823 62.02L7.219 62.6729C7.20853 62.6538 7.19456 62.6347 7.18408 62.6188Z",
	fill: "#F6C267"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.21899 62.6761L8.44822 62.0232C8.45869 62.0423 8.47266 62.0614 8.48314 62.0773L7.25392 62.7303C7.24344 62.7112 7.23296 62.6921 7.21899 62.6761Z",
	fill: "#F5BF5E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.25391 62.7303L8.48313 62.0774C8.4936 62.0965 8.50408 62.1124 8.51456 62.1315L7.28534 62.7845C7.27486 62.7654 7.26438 62.7494 7.25391 62.7303Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.28528 62.7843L8.5145 62.1313C8.52498 62.1505 8.53545 62.1664 8.54593 62.1855L7.31671 62.8384C7.30623 62.8193 7.29575 62.8034 7.28528 62.7843Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.31677 62.8385L8.54599 62.1855C8.55647 62.2047 8.56695 62.2238 8.57742 62.2429L7.3482 62.8958C7.33773 62.8767 7.32725 62.8576 7.31677 62.8385Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.34814 62.8927L8.57737 62.2397C8.58784 62.2589 8.59832 62.2812 8.6088 62.3003L7.37957 62.9532C7.3691 62.9341 7.35862 62.9118 7.34814 62.8927Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.3761 62.9532L8.60532 62.3003C8.6158 62.3194 8.62627 62.3417 8.63675 62.3608L7.40753 63.0137C7.39705 62.9946 7.38657 62.9723 7.3761 62.9532Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.40759 63.0138L8.63681 62.3608C8.64729 62.3831 8.65777 62.4054 8.66824 62.4277L7.43902 63.0807C7.42855 63.0584 7.41807 63.0361 7.40759 63.0138Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.43896 63.0807L8.66819 62.4277C8.67866 62.45 8.68914 62.4755 8.69962 62.4978L7.47039 63.1507C7.45992 63.1285 7.44944 63.103 7.43896 63.0807Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.47046 63.1507L8.69968 62.4978C8.71016 62.5233 8.72063 62.5456 8.73111 62.5711L7.50189 63.224C7.49141 63.1985 7.48094 63.1762 7.47046 63.1507Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.49829 63.224L8.72751 62.571C8.73799 62.5965 8.74847 62.622 8.75894 62.6507L7.52972 63.3036C7.51924 63.2781 7.50877 63.2527 7.49829 63.224Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.52979 63.3036L8.75901 62.6506C8.76948 62.6761 8.77996 62.7048 8.78694 62.7303L7.55772 63.3832C7.54725 63.3577 7.54026 63.3291 7.52979 63.3036Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.55774 63.3832L8.78696 62.7302C8.79744 62.7589 8.80442 62.7876 8.8149 62.8162L7.58568 63.4692C7.5752 63.4405 7.56822 63.4118 7.55774 63.3832Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.58569 63.4659L8.81492 62.813C8.82539 62.8417 8.83238 62.8703 8.83936 62.899L7.61014 63.5519C7.60315 63.5233 7.59268 63.4946 7.58569 63.4659Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.61353 63.5553L8.84275 62.9023C8.84973 62.931 8.86021 62.9629 8.86719 62.9915L7.63797 63.6445C7.63099 63.6158 7.624 63.5839 7.61353 63.5553Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.63806 63.6444L8.86728 62.9915C8.87427 63.0233 8.88125 63.052 8.88824 63.0838L7.65901 63.7368C7.65203 63.7049 7.64505 63.6762 7.63806 63.6444Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.65894 63.7367L8.88816 63.0837C8.89514 63.1156 8.90213 63.1474 8.90911 63.1793L7.67989 63.8322C7.6729 63.8004 7.66592 63.7685 7.65894 63.7367Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.67993 63.8324L8.90915 63.1794C8.91614 63.2113 8.91963 63.2463 8.92661 63.2782L7.69739 63.9311C7.6939 63.8993 7.68692 63.8642 7.67993 63.8324Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.69385 63.931L8.92307 63.2781C8.93005 63.3131 8.93355 63.345 8.93704 63.38L7.70782 64.0329C7.70432 63.9979 7.69734 63.9629 7.69385 63.931Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.70789 64.0328L8.93711 63.3799C8.9406 63.4181 8.94409 63.4531 8.94758 63.4914L7.71836 64.1443C7.71836 64.1061 7.71138 64.071 7.70789 64.0328Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.7218 64.1444L8.95102 63.4915C8.95102 63.5297 8.95801 63.5711 8.95801 63.6093L7.72879 64.2622C7.72879 64.224 7.72529 64.1826 7.7218 64.1444Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.72876 64.2623L8.95798 63.6094C8.95798 63.6508 8.95798 63.6922 8.95798 63.7304L7.72876 64.3833C7.72876 64.3419 7.72876 64.3005 7.72876 64.2623Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.72883 64.3866L8.95806 63.7336C8.95806 63.775 8.95806 63.8196 8.95456 63.8579L7.72534 64.5108C7.72534 64.4694 7.72883 64.428 7.72883 64.3866Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.72532 64.5138L8.95454 63.8608C8.95454 63.9054 8.94756 63.9468 8.94407 63.9914L7.71484 64.6444C7.71834 64.603 7.72183 64.5584 7.72532 64.5138Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.7148 64.6412L8.94402 63.9883C8.93704 64.0361 8.93005 64.0807 8.92307 64.1252L7.69385 64.7782C7.70083 64.7336 7.70782 64.689 7.7148 64.6412Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.69393 64.7814L8.92315 64.1284C8.91268 64.1826 8.89871 64.2367 8.88474 64.2845L7.65552 64.9374C7.66949 64.8865 7.68345 64.8355 7.69393 64.7814Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.65546 64.9376L8.88468 64.2847C8.80087 64.5586 8.65071 64.7561 8.44468 64.8675L7.21545 65.5205C7.42149 65.409 7.57165 65.2115 7.65546 64.9376Z",
	fill: "#F4B648"
})), /* @__PURE__ */ React.createElement("path", {
	d: "M7.15271 58.9242L8.38542 58.2712L8.41336 59.0962L7.18065 59.7491L7.15271 58.9242Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("mask", {
	id: "mask2_4473_29983",
	style: { maskType: "luminance" },
	maskUnits: "userSpaceOnUse",
	x: 2,
	y: 42,
	width: 6,
	height: 3
}, /* @__PURE__ */ React.createElement("path", {
	d: "M2.2533 43.0497L3.48252 42.3968C4.46031 42.1674 6.15049 42.5592 7.71844 43.3841L6.48922 44.0371C4.92127 43.2122 3.23109 42.8204 2.2533 43.0497Z",
	fill: "white"
})), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask2_4473_29983)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M2.2533 43.0495L3.48252 42.3966C3.51744 42.387 3.55236 42.3806 3.58728 42.3743L2.35806 43.0272C2.32314 43.0336 2.28472 43.04 2.2533 43.0495Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M2.36157 43.0273L3.59079 42.3743C3.64318 42.3648 3.69556 42.3584 3.75143 42.3521L2.52221 43.005C2.46634 43.0114 2.41395 43.0177 2.36157 43.0273Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M2.52222 43.0051L3.75144 42.3521C3.8108 42.3457 3.87017 42.3394 3.92954 42.3362L2.70031 42.9891C2.63746 42.9891 2.57809 42.9987 2.52222 43.0051Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M2.70032 42.989L3.92954 42.336C3.99589 42.3329 4.06224 42.3297 4.12859 42.3329L2.89937 42.9858C2.82953 42.9858 2.76318 42.9858 2.70032 42.989Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M2.89929 42.986L4.12851 42.333C4.20185 42.333 4.27518 42.333 4.35201 42.3394L3.12279 42.9923C3.04596 42.9891 2.97263 42.986 2.89929 42.986Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M3.1228 42.9923L4.35202 42.3394C4.43234 42.3425 4.51615 42.3521 4.59996 42.3585L3.37074 43.0114C3.28693 43.0019 3.20312 42.9955 3.1228 42.9923Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M3.36731 43.0145L4.59653 42.3616C4.68383 42.3711 4.77463 42.3839 4.86892 42.3966L3.63969 43.0496C3.5489 43.0336 3.4581 43.0241 3.36731 43.0145Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M3.63965 43.0497L4.86887 42.3967C4.96665 42.4127 5.06443 42.4286 5.1657 42.4509L3.93648 43.1038C3.83521 43.0847 3.73743 43.0656 3.63965 43.0497Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M3.93652 43.1036L5.16575 42.4507C5.27051 42.473 5.37876 42.4953 5.48702 42.5239L4.2578 43.1769C4.14954 43.1514 4.04129 43.1259 3.93652 43.1036Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M4.26123 43.1739L5.49045 42.521C5.6022 42.5497 5.71744 42.5815 5.83268 42.6134L4.60346 43.2663C4.48822 43.2313 4.37298 43.2026 4.26123 43.1739Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M4.60352 43.2694L5.83274 42.6165C5.95147 42.6515 6.07369 42.6897 6.19592 42.7311L4.96669 43.3841C4.84447 43.3427 4.72225 43.3044 4.60352 43.2694Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M4.96667 43.3841L6.1959 42.7312C6.32161 42.7726 6.44733 42.8172 6.57304 42.8682L5.34382 43.5211C5.21811 43.4733 5.09239 43.4287 4.96667 43.3841Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5.34387 43.5177L6.57309 42.8647C6.7023 42.9125 6.82802 42.9667 6.95723 43.0208L5.728 43.6738C5.5988 43.6196 5.46959 43.5655 5.34387 43.5177Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5.72791 43.6739L6.95713 43.021C7.08634 43.0751 7.21205 43.1357 7.34126 43.1962L6.11204 43.8491C5.98283 43.7886 5.85711 43.7313 5.72791 43.6739Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6.11206 43.849L7.34128 43.196C7.467 43.2566 7.59271 43.3203 7.71843 43.384L6.48921 44.0369C6.36349 43.97 6.23778 43.9063 6.11206 43.849Z",
	fill: "#F4B648"
})), /* @__PURE__ */ React.createElement("path", {
	d: "M6.48922 44.037C9.89054 45.8302 11.4236 48.8433 11.4166 51.1971C11.4096 53.3056 10.2817 54.2356 8.85687 55.2517C7.55082 56.1785 7.0724 57.2933 7.15622 58.9209L7.18415 59.7426L4.87587 58.5259L4.8165 57.6883C4.6419 55.9174 5.18317 54.3694 6.66732 53.2897C8.0048 52.3469 8.74862 51.5283 8.75211 50.1332C8.7556 48.5503 7.81273 46.9991 5.94795 45.9863C4.88285 45.4257 3.69554 45.1741 2.9587 45.3747L2.2533 43.0464C3.23109 42.8171 4.92127 43.2089 6.48922 44.0338V44.037Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("mask", {
	id: "mask3_4473_29983",
	style: { maskType: "luminance" },
	maskUnits: "userSpaceOnUse",
	x: 6,
	y: 43,
	width: 7,
	height: 16
}, /* @__PURE__ */ React.createElement("path", {
	d: "M6.48926 44.037L7.71848 43.384C11.1198 45.1772 12.6528 48.1903 12.6458 50.5441C12.6389 52.6526 11.5109 53.5827 10.0861 54.5987C8.78008 55.5256 8.30166 56.6404 8.38547 58.2679L7.15625 58.9209C7.07244 57.2933 7.55086 56.1785 8.85691 55.2517C10.2817 54.2324 11.4096 53.3024 11.4166 51.197C11.4236 48.8401 9.89406 45.827 6.48926 44.037Z",
	fill: "white"
})), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask3_4473_29983)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M6.48926 44.037L7.71848 43.384C7.71848 43.384 7.71848 43.384 7.72197 43.384L6.49275 44.037C6.49275 44.037 6.49275 44.037 6.48926 44.037Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6.49292 44.0404L7.72214 43.3875C7.85484 43.4575 7.98754 43.5308 8.11675 43.604L6.88753 44.257C6.75832 44.1837 6.62911 44.1105 6.49292 44.0404Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6.88733 44.2599L8.11655 43.6069C8.24227 43.6802 8.36798 43.7566 8.49021 43.8331L7.26099 44.486C7.13876 44.4096 7.01304 44.3331 6.88733 44.2599Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.26099 44.486L8.49021 43.833C8.60894 43.9094 8.72418 43.9859 8.83942 44.0623L7.6102 44.7153C7.49845 44.6357 7.37972 44.5592 7.26099 44.486Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.61023 44.7154L8.83945 44.0625C8.94771 44.1389 9.05596 44.2154 9.15723 44.2918L7.92801 44.9448C7.82325 44.8683 7.71848 44.7919 7.61023 44.7154Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.92798 44.9447L9.1572 44.2917C9.25149 44.3618 9.34228 44.4319 9.43308 44.5051L8.20385 45.1581C8.11306 45.0848 8.02227 45.0148 7.92798 44.9447Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M8.20386 45.1581L9.43308 44.5051C9.51689 44.572 9.59721 44.6389 9.67753 44.709L8.44831 45.3619C8.36799 45.2918 8.28767 45.225 8.20386 45.1581Z",
	fill: "#F5BF5E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M8.44836 45.3619L9.67759 44.709C9.75441 44.7759 9.82775 44.8396 9.90108 44.9065L8.67186 45.5594C8.59852 45.4925 8.52519 45.4256 8.44836 45.3619Z",
	fill: "#F6C267"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M8.67529 45.5626L9.90452 44.9097C9.97785 44.9766 10.0477 45.0403 10.1175 45.1103L8.88831 45.7633C8.81847 45.6964 8.74863 45.6295 8.67529 45.5626Z",
	fill: "#F6C56E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M8.88489 45.7601L10.1141 45.1072C10.1874 45.1772 10.2573 45.2505 10.3271 45.3206L9.09791 45.9735C9.02806 45.9003 8.95822 45.8302 8.88489 45.7601Z",
	fill: "#F7C874"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M9.10132 45.9767L10.3305 45.3237C10.4213 45.4161 10.5086 45.5117 10.5959 45.6072L9.36672 46.2601C9.28291 46.1646 9.19211 46.069 9.10132 45.9767Z",
	fill: "#F7CA79"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M9.36328 46.2601L10.5925 45.6072C10.7287 45.7601 10.8579 45.9129 10.9766 46.069L9.74741 46.722C9.62519 46.5659 9.49598 46.413 9.36328 46.2601Z",
	fill: "#F7CB7E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M9.74744 46.722L10.9767 46.0691C11.05 46.1615 11.1163 46.2538 11.1862 46.3462L9.95696 46.9991C9.89061 46.9068 9.82077 46.8144 9.74744 46.722Z",
	fill: "#F7CA79"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M9.95691 47.0023L11.1861 46.3494C11.2245 46.4035 11.263 46.4577 11.3014 46.5118L10.0721 47.1647C10.0337 47.1106 9.99532 47.0565 9.95691 47.0023Z",
	fill: "#F7C874"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10.0721 47.1647L11.3014 46.5117C11.3363 46.5627 11.3677 46.6136 11.4026 46.6614L10.1734 47.3144C10.142 47.2634 10.1071 47.2124 10.0721 47.1647Z",
	fill: "#F6C56E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10.1735 47.3143L11.4027 46.6614C11.4341 46.7092 11.4655 46.7569 11.4935 46.8047L10.2643 47.4576C10.2328 47.4099 10.2049 47.3621 10.1735 47.3143Z",
	fill: "#F6C267"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10.2643 47.4579L11.4935 46.8049C11.5214 46.8463 11.5459 46.8909 11.5738 46.9323L10.3446 47.5853C10.3202 47.5439 10.2922 47.4993 10.2643 47.4579Z",
	fill: "#F5BF5E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10.3411 47.5851L11.5703 46.9321C11.5947 46.9735 11.6227 47.0181 11.6471 47.0595L10.4179 47.7125C10.3934 47.6711 10.369 47.6265 10.3411 47.5851Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10.4178 47.7125L11.6471 47.0596C11.6715 47.1042 11.696 47.1456 11.7204 47.1902L10.4912 47.8431C10.4667 47.7985 10.4423 47.7571 10.4178 47.7125Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10.4912 47.8463L11.7204 47.1934C11.7449 47.238 11.7693 47.2825 11.7938 47.3271L10.5645 47.9801C10.5401 47.9355 10.5157 47.8909 10.4912 47.8463Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10.5646 47.9801L11.7938 47.3271C11.8182 47.3717 11.8392 47.4163 11.8636 47.4609L10.6344 48.1139C10.61 48.0693 10.589 48.0247 10.5646 47.9801Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10.6344 48.1139L11.8636 47.4609C11.8881 47.5087 11.9125 47.5565 11.9335 47.6043L10.7042 48.2572C10.6798 48.2094 10.6588 48.1617 10.6344 48.1139Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10.7042 48.2604L11.9334 47.6074C11.9579 47.6584 11.9823 47.7093 12.0068 47.7603L10.7776 48.4132C10.7531 48.3623 10.7287 48.3113 10.7042 48.2604Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10.7776 48.4132L12.0068 47.7603C12.0313 47.8112 12.0522 47.8622 12.0732 47.9131L10.8439 48.5661C10.823 48.5151 10.7985 48.4642 10.7776 48.4132Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10.8439 48.5663L12.0731 47.9133C12.0975 47.9707 12.122 48.028 12.1464 48.0853L10.9172 48.7383C10.8928 48.6809 10.8718 48.6236 10.8439 48.5663Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10.9172 48.7381L12.1465 48.0852C12.1709 48.1425 12.1919 48.1999 12.2128 48.2572L10.9836 48.9101C10.9626 48.8528 10.9382 48.7955 10.9172 48.7381Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10.9836 48.9103L12.2129 48.2573C12.2373 48.3178 12.2583 48.3784 12.2792 48.4389L11.05 49.0918C11.029 49.0313 11.0081 48.9708 10.9836 48.9103Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11.0499 49.0948L12.2791 48.4419C12.3001 48.5024 12.3211 48.5661 12.3385 48.6266L11.1093 49.2796C11.0883 49.2191 11.0709 49.1554 11.0499 49.0948Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11.1094 49.2797L12.3386 48.6267C12.3596 48.6904 12.377 48.7541 12.3945 48.8178L11.1652 49.4708C11.1478 49.4071 11.1268 49.3434 11.1094 49.2797Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11.1687 49.474L12.3979 48.821C12.4154 48.8847 12.4328 48.9516 12.4503 49.0153L11.2211 49.6683C11.2036 49.6046 11.1862 49.5377 11.1687 49.474Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11.2211 49.6683L12.4503 49.0154C12.4678 49.0823 12.4817 49.1492 12.4992 49.216L11.27 49.869C11.256 49.8021 11.2385 49.7352 11.2211 49.6683Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11.2665 49.8656L12.4957 49.2126C12.5097 49.2795 12.5236 49.3464 12.5376 49.4133L11.3084 50.0663C11.2944 49.9994 11.2804 49.9325 11.2665 49.8656Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11.3083 50.0694L12.5376 49.4165C12.5515 49.4866 12.562 49.5567 12.5725 49.6299L11.3433 50.2828C11.3328 50.2128 11.3188 50.1427 11.3083 50.0694Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11.3433 50.2797L12.5725 49.6267C12.583 49.6968 12.5934 49.77 12.6004 49.8401L11.3712 50.4931C11.3642 50.423 11.3537 50.3497 11.3433 50.2797Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11.3748 50.493L12.604 49.8401C12.6145 49.9165 12.6214 49.993 12.6284 50.0694L11.3992 50.7224C11.3922 50.6459 11.3852 50.5695 11.3748 50.493Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11.3956 50.7225L12.6249 50.0696C12.6318 50.1492 12.6353 50.2288 12.6388 50.3053L11.4096 50.9582C11.4096 50.8786 11.4026 50.8022 11.3956 50.7225Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11.4131 50.9581L12.6423 50.3052C12.6423 50.3848 12.6458 50.4676 12.6458 50.5472C12.6458 50.5472 12.6458 50.5504 12.6458 50.5536L11.4166 51.2066C11.4166 51.2066 11.4166 51.2034 11.4166 51.2002C11.4166 51.1206 11.4166 51.0409 11.4131 50.9581Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11.4167 51.2035L12.6459 50.5505C12.6459 50.6493 12.6459 50.7448 12.6389 50.8372L11.4097 51.4901C11.4132 51.3978 11.4167 51.3022 11.4167 51.2035Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11.4062 51.4901L12.6354 50.8372C12.6284 50.9391 12.6214 51.0378 12.6109 51.1334L11.3817 51.7863C11.3922 51.6908 11.4027 51.592 11.4062 51.4901Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11.3817 51.7862L12.6109 51.1333C12.5969 51.248 12.5794 51.3563 12.562 51.4614L11.3328 52.1143C11.3537 52.0092 11.3712 51.8977 11.3817 51.7862Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11.3328 52.1144L12.562 51.4614C12.534 51.6016 12.5026 51.7322 12.4642 51.8596L11.235 52.5125C11.2734 52.3851 11.3048 52.2513 11.3328 52.1144Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11.235 52.5157L12.4642 51.8628C12.0906 53.0986 11.1756 53.8248 10.0861 54.602C9.28293 55.1721 8.79054 55.8155 8.55307 56.6022L7.32385 57.2551C7.56132 56.4652 8.0537 55.825 8.85689 55.2549C9.94643 54.4777 10.8614 53.7515 11.235 52.5157Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.32036 57.255L8.54958 56.6021C8.51117 56.7263 8.47974 56.8537 8.4553 56.9843L7.22607 57.6372C7.25052 57.5066 7.28195 57.3792 7.32036 57.255Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.22614 57.6373L8.45536 56.9844C8.4344 57.0895 8.42044 57.1946 8.40647 57.3029L7.17725 57.9558C7.19121 57.8475 7.20518 57.7392 7.22614 57.6373Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.17715 57.9591L8.40638 57.3062C8.3959 57.4049 8.38542 57.5036 8.38193 57.6056L7.15271 58.2585C7.15969 58.1566 7.16668 58.0578 7.17715 57.9591Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.15274 58.2552L8.38196 57.6023C8.37497 57.6978 8.37497 57.7966 8.37497 57.8953L7.14575 58.5483C7.14575 58.4495 7.14575 58.3508 7.15274 58.2552Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.14233 58.5482L8.37156 57.8953C8.37156 57.994 8.37156 58.0927 8.37854 58.1947L7.14932 58.8476C7.14583 58.7457 7.14233 58.6469 7.14233 58.5482Z",
	fill: "#F4B648"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.14929 58.8475L8.37851 58.1946C8.37851 58.2201 8.37851 58.2455 8.38201 58.271L7.15278 58.924C7.15278 58.8985 7.15278 58.873 7.14929 58.8475Z",
	fill: "#F4B648"
}))), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", {
	id: "paint0_linear_4473_29983",
	x1: 16.6617,
	y1: 6.20766,
	x2: 41.3882,
	y2: 60.1475,
	gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
	offset: .06,
	stopColor: "#FEFEFE"
}), /* @__PURE__ */ React.createElement("stop", {
	offset: 1,
	stopColor: "#B0BEC5"
})), /* @__PURE__ */ React.createElement("linearGradient", {
	id: "paint1_linear_4473_29983",
	x1: 15.4883,
	y1: 67.6321,
	x2: 44.822,
	y2: 67.6321,
	gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
	offset: .38,
	stopColor: "#FEFEFE"
}), /* @__PURE__ */ React.createElement("stop", {
	offset: .84,
	stopColor: "#B0BEC5"
})), /* @__PURE__ */ React.createElement("linearGradient", {
	id: "paint2_linear_4473_29983",
	x1: 26.1602,
	y1: 65.1731,
	x2: 33.5774,
	y2: 65.1731,
	gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
	offset: .38,
	stopColor: "#FEFEFE"
}), /* @__PURE__ */ React.createElement("stop", {
	offset: .84,
	stopColor: "#B0BEC5"
})), /* @__PURE__ */ React.createElement("linearGradient", {
	id: "paint3_linear_4473_29983",
	x1: 2.16943,
	y1: 41.6003,
	x2: 64.4407,
	y2: 41.6003,
	gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
	offset: .2,
	stopColor: "#F7F9FC"
}), /* @__PURE__ */ React.createElement("stop", {
	offset: .52,
	stopColor: "#F7F9FC"
})), /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_4473_29983" }, /* @__PURE__ */ React.createElement("rect", {
	width: 66.0777,
	height: 82,
	fill: "white",
	transform: "translate(0.961182)"
}))));
export default SvgErrorEmpty;
